export interface IBowtieExpandedBarriers {
    consequencesExpandedBarriers: ExpandedBarrier[]
    threatsExpandedBarriers: ExpandedBarrier[]
}

export interface IExpandedBarriersAction {
    type:
        | 'SET_THREAT_EXPANDED_BARRIERS'
        | 'SET_CONSEQUENCE_EXPANDED_BARRIERS'
        | 'ADD_THREAT_EXPANDED_BARRIERS'
        | 'ADD_CONSEQUENCE_EXPANDED_BARRIERS' // eslint-disable-line max-len, prettier/prettier
    payload: {
        newExpandedBarriers: ExpandedBarrier[]
    }
}

interface ExpandedBarrier {
    barrierId: string
    rootXIndex: number
    escalations: { escId: string; x: number; y: number }[]
}

const initialState: IBowtieExpandedBarriers = {
    consequencesExpandedBarriers: [],
    threatsExpandedBarriers: []
}

export function bowtieExpandedBarriersReducer(
    state = initialState,
    action: IExpandedBarriersAction
): IBowtieExpandedBarriers {
    switch (action.type) {
        case 'SET_THREAT_EXPANDED_BARRIERS': {
            const { newExpandedBarriers } = action.payload

            return {
                ...state,
                threatsExpandedBarriers: newExpandedBarriers
            }
        }
        case 'ADD_THREAT_EXPANDED_BARRIERS': {
            const { newExpandedBarriers } = action.payload

            return {
                ...state,
                threatsExpandedBarriers: [...state.threatsExpandedBarriers, ...newExpandedBarriers]
            }
        }
        case 'SET_CONSEQUENCE_EXPANDED_BARRIERS': {
            const { newExpandedBarriers } = action.payload

            return {
                ...state,
                consequencesExpandedBarriers: newExpandedBarriers
            }
        }
        case 'ADD_CONSEQUENCE_EXPANDED_BARRIERS': {
            const { newExpandedBarriers } = action.payload

            return {
                ...state,
                consequencesExpandedBarriers: [...state.consequencesExpandedBarriers, ...newExpandedBarriers]
            }
        }
        default:
            return state
    }
}
